(function () {
	const facetsMenu = () => {
		$('html.js .no_submit').click(function(e){
			e.preventDefault();
		});
		$('.open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask').click(function(){
			$('#open_filters_menu').toggleClass('show_menu');
			$('body').toggleClass('overflow-hidden');
		});

        $('#FacetsWrapperDesktopSidebar #Filter-Price-LTE').on('change', function () {
          console.log($(this).val());
        });

		$('.filter-products-btn').on('click', function(e){
			e.preventDefault;
			$('.collection-custom-filter').stop().toggleClass('active');
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		facetsMenu();
	});
  
	document.addEventListener("shopify:section:load", function (event) {
		facetsMenu();
        console.log("Section loaded:", event.detail.sectionId);
        $('#FacetsWrapperDesktopSidebar #Filter-Price-LTE').on('change', function () {
          console.log($(this).val());
        });
	});

})();
